import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flex: '0 0 auto',
    width: '100%',
    cursor: 'pointer',
    userSelect: 'none',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',

    '&:hover': {
      backgroundColor: theme.palette.sidebar.background.hover,
    },
  },

  activeContainer: {
    backgroundColor: theme.palette.sidebar.background.hover,
  },

  menuItem: {
    display: 'inline-flex',
    color: theme.palette.action.hover,
    alignItems: 'center',
    padding: theme.spacing(0),
    height: theme.spacing(3.75),
    width: '100%',
  },

  label: {
    marginRight: 'auto',
  },

  disabled: {
    color: theme.palette.sidebar.text.disabled,
  },

  primary: {
    color: theme.palette.text.primary,
  },
}));
